import { combineReducers } from 'redux'
import { sectionReducer } from './sectionsReducer'
import { authReducer } from './authReducer'

export const rootReducer = combineReducers({
  sections: sectionReducer,
  auth: authReducer
})